import React from "react";

const TrustedCompanies = () => {
  const companyLogos = [
    {
      name: "Beckers",
      logo: "../assets/images/new_index/Trusted Companies/beckers.svg",
    },
    {
      name: "Sasol",
      logo: "../assets/images/new_index/Trusted Companies/sasol.svg",
    },
    {
      name: "Mediwell",
      logo: "../assets/images/new_index/Trusted Companies/mediwell.svg",
    },
    {
      name: "Specsaver",
      logo: "../assets/images/new_index/Trusted Companies/specsaver.svg",
    },
    {
      name: "PNG",
      logo: "../assets/images/new_index/Trusted Companies/png.svg",
    },
    {
      name: "Torga",
      logo: "../assets/images/new_index/Trusted Companies/Torga.svg",
    },
    {
      name: "Whitestone",
      logo: "../assets/images/new_index/Trusted Companies/whitestone.svg",
    },
    {
      name: "Spar",
      logo: "../assets/images/new_index/Trusted Companies/spar.svg",
    },
    {
      name: "Spar",
      logo: "../assets/images/StartSmart/san hair.svg",
    },
  ];

  return (
    <div className="container">
      <div className="trustedcompanies__heading">
        TRUSTED BY OVER 1000+ COMPANIES
      </div>
      <div className="trustedcompanies__logos">
        {companyLogos.map((company, index) => (
          <span
            key={index}
            className="trustedcompanies__companylogo text-center"
          >
            <a href={void 0}>
              <img
                src={company.logo}
                className=" trustedcompanies__img"
                alt={company.name}
              />
            </a>
          </span>
        ))}
      </div>
    </div>
  );
};

export default TrustedCompanies;
